import React, { useEffect, useMemo } from "react";
import type { Errors } from "~/types/error";
import { errorToArray } from "~/utils/authUtils";
import toast from "react-hot-toast";
import clsx from "clsx";

interface ErrorDisplayProps {
  error: Errors | undefined;
}

const ErrorDisplay: React.FC<
  ErrorDisplayProps
> = ({ error }) => {
  return (
    <div className="">
      {error &&
        errorToArray(error).length > 0 && (
          <div
            className={clsx(
              "text-12",
              "text-red-500",
            )}
          >
            {errorToArray(error).map((el, i) => {
              return <div key={i}>{el}</div>;
            })}
          </div>
        )}
    </div>
  );
};

/* 
errorが変更された時と、最初のレンダリング時にエラーをトーストで表示する
*/
export const ErrorDisplayToast: React.FC<
  ErrorDisplayProps
> = ({ error }) => {
  const memoizedError = useMemo(
    () => error,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(error)],
  );
  useEffect(() => {
    if (!memoizedError) {
      return;
    }
    const errors = errorToArray(memoizedError);
    toast.error(errors.join("\n"), {
      duration: 4000,
    });
  }, [memoizedError]);

  return <div className=""></div>;
};

export default ErrorDisplay;
